
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import defaultPhoto from 'img/default-photo.png'

export const CommunityInvite = ({ challengeOwnerPics, sponsorEmail,classes }) => (
    <div className={classes.challengeblock}>
      <h3 className={classes.header}>Communities Invited</h3>
      <UserProfileGrid
        userAvtar={challengeOwnerPics}
        ownerEmail={sponsorEmail || ''}
      />
    </div>
  );
  


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  userinfo: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '8px 0',
  },
  useRole: {
    marginLeft: '8px',
  },
  profilePic: {
    height: '40px',
    width: '40px',
    borderRadius: '50%',
    boxShadow: '0px 2px 3px #33333399',
    marginLeft: '.5rem',
  },
  textsmall: {
    fontFamily: 'VodafoneRg-regular',
    fontSize: '0.9rem',
    textAlign: 'left',
    color: '#333',
    lineHeight: '1.4',
  },
}));

const UserProfileGrid = ({ userAvtar, ownerEmail }) => {
  const classes = useStyles();

  return (
    <div className={classes.userinfo}>
      <img
        src={userAvtar}
        className={classes.profilePic}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = defaultPhoto;
        }}
        alt="User Profile"
      />
      <div className={classes.useRole}>
        <p className={classes.textsmall}>
          {ownerEmail?.length > 0 ? ownerEmail : 'Not Available'}
        </p>
      </div>
    </div>
  );
};

export default UserProfileGrid;
